import { ETH } from '../constants/assets'
import type { ChainConfig } from '../types'
import { getQuickNodeRpcUrl } from '../utils/getQuickNodeRpcUrl'

export const ROBINHOOD = {
  name: 'robinhood',
  chainId: 4663,
  averageBlockTimeSeconds: 0.25,
  explorerUrl: 'https://robinhoodchain.blockscout.com',
  nativeAsset: ETH,
  slip44: 60,
  wrappedNativeAsset: '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73',
  blockscoutApiUrl: 'https://robinhoodchain.blockscout.com/api',
  etherscanSupported: false,
  publicRpcUrls: ['https://rpc.mainnet.chain.robinhood.com'],
  getPrivateRpcUrls: () => {
    const robinhood: string[] = []
    process.env.ROUTEME_API_KEY && robinhood.push(`https://lb.routeme.sh/rpc/4663/${process.env.ROUTEME_API_KEY}`)
    const quickNodeUrl = getQuickNodeRpcUrl('robinhood')
    quickNodeUrl && robinhood.push(quickNodeUrl)
    process.env.ALCHEMY_API_KEY &&
      robinhood.push(`https://robinhood-mainnet.g.alchemy.com/v2/${process.env.ALCHEMY_API_KEY}`)
    return robinhood
  },
} as const satisfies ChainConfig
